import { PartnersService } from 'src/app/pages/partiners/partiners.service';
import { ServicesService } from '../services.service';
import { Component, Injector } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Service } from '../service.model';
import { Validators } from '@angular/forms';
import { REGEX } from 'src/app/app.validators';
import { Partner } from '../../partiners/partner.model';
import { ApiConstants } from 'src/app/shared/services/api-constants.service';

@Component({
    selector: 'ng-service',
    templateUrl: 'service-form.component.html'
})
export class ServiceFormComponent extends BaseFormComponent<Service>{

    public partners:Array<Partner>;
    public bonusFormats:Array<any>;

    constructor(
        protected injector: Injector,
        protected servicesServ:ServicesService,
        public  partinerServ:PartnersService,
        public constantServ:ApiConstants,
    ) {
        super(injector,'service','/admin/services',Service.fromJsonToObject,servicesServ);
    }

    protected initChildMethods(): void {
        
        this.loadConstants();

        this.formSubscription.add(this.partinerServ.getAll().subscribe(partners => {
            this.partners=partners
        }))
    }

    loadConstants() {
        const bf=JSON.parse(localStorage.getItem("constants"));

        if(!!bf && bf.bonusFormats){
            this.bonusFormats=bf.bonusFormats;
        }else{
            this.formSubscription.add(this.constantServ.getAllBonusFormats().subscribe(bonusFormats => {
                this.bonusFormats=bonusFormats;
            }))
        }
    }


    protected buildForm(): void {

        this.objectForm=this.formBuilder.group({

            name:this.formBuilder.control(null,[Validators.required]),

            percentagems_id:this.formBuilder.control(null,[Validators.required]),

            description:this.formBuilder.control(null),

            khuzelaBonus:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternQuantity)]),

            clubBonus:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternQuantity)]),

            partnerBonus:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.numberPatternQuantity)]),

            estado_id:this.formBuilder.control(null),

            partners_id:this.formBuilder.control(null,[Validators.required]),

            id:this.formBuilder.control(null)

          })
    }

    protected initChildProprieties(): void {
        this.bonusFormats=new Array<any>();
    }

    

}